"use client";

import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Loader, Utensils } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useRef, useState } from "react";
export default function ContactForm() {
  return <section id="контактна-форма" className="relative min-h-screen py-20 px-6 overflow-hidden" style={{
    background: "linear-gradient(135deg, hsl(15 100% 92%) 0%, hsl(25 100% 88%) 100%)"
  }}>
            {}
            <FloatingUtensil />
            
            <div className="container mx-auto max-w-2xl relative z-10">
                <FormProvider className="relative" formId="contact_form_contact" sectionName="contact-form" defaultValues={{
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: ""
      }} validationRules={{
        name: {
          required: true,
          minLength: 2
        },
        email: {
          required: true,
          pattern: "email"
        },
        phone: {
          required: false
        },
        subject: {
          required: false
        },
        message: {
          required: true,
          minLength: 10
        }
      }} submitText="Изпрати" successMessage="Благодарим ви! Ще се свържем с вас скоро." errorMessage="Грешка при изпращане. Моля, опитайте отново.">
                    <ContactFormContent />
                </FormProvider>
            </div>
        </section>;
}
function ContactFormContent() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  const {
    ref: titleRef,
    isVisible: titleVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: field1Ref,
    isVisible: field1Visible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: field2Ref,
    isVisible: field2Visible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: field3Ref,
    isVisible: field3Visible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: field4Ref,
    isVisible: field4Visible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: field5Ref,
    isVisible: field5Visible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: buttonRef,
    isVisible: buttonVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  if (isSubmitted && !submitError) {
    return <div className="p-8 rounded-lg transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]" style={{
      background: "linear-gradient(135deg, hsl(95 50% 96%) 0%, hsl(95 50% 92%) 100%)",
      boxShadow: "inset 0 2px 8px hsl(0 0% 100% / 0.4), inset 0 -3px 8px hsl(0 0% 0% / 0.08), 0 6px 16px hsl(0 0% 0% / 0.12)"
    }}>
                <p className="text-[hsl(95_50%_25%)] text-lg font-semibold mb-4">{successMessage}</p>
                <Button onClick={resetForm} variant="outline" className="transition-transform duration-[var(--duration-fast)] ease-[var(--ease-spring)] hover:scale-[1.03] active:scale-[0.98]">
                    Изпрати ново съобщение
                </Button>
            </div>;
  }
  return <div className="p-10 rounded-lg transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]" style={{
    background: "hsl(0 0% 100% / 0.85)",
    boxShadow: "inset 0 3px 10px hsl(0 0% 100% / 0.5), inset 0 -4px 10px hsl(0 0% 0% / 0.06), 0 8px 24px hsl(0 0% 0% / 0.15)"
  }}>
            <div ref={titleRef} className={`mb-8 text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${titleVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-3'}`}>
                <h2 className="font-display text-[40px] leading-[1.2] font-bold tracking-tight mb-2" style={{
        color: "var(--color-primary)"
      }}>
                    Контактна форма
                </h2>
                <p className="text-muted-foreground text-base">Свържете се с нас за резервации, запитвания или въпроси</p>
            </div>

            <Form onSubmit={handleSubmit}>
                <div className="space-y-5">
                    {}
                    <div ref={field1Ref} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${field1Visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-3'}`} style={{
          transitionDelay: '50ms'
        }}>
                        <FormField control={control} name="name" rules={{
            required: "Името е задължително",
            minLength: {
              value: 2,
              message: "Минимум 2 символа"
            }
          }} render={({
            field
          }) => <FormItem>
                                    <FormLabel className="text-foreground font-semibold">Име</FormLabel>
                                    <FormControl>
                                        <Input placeholder="Иван Иванов" {...field} className="rounded-lg transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] focus:shadow-clay-hover" style={{
                boxShadow: "inset 0 2px 6px hsl(0 0% 0% / 0.1), inset 0 -1px 3px hsl(0 0% 100% / 0.3)"
              }} />
                                    </FormControl>
                                    <FormMessage />
                                </FormItem>} />
                    </div>

                    {}
                    <div ref={field2Ref} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${field2Visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-3'}`} style={{
          transitionDelay: '100ms'
        }}>
                        <FormField control={control} name="email" rules={{
            required: "Имейлът е задължителен",
            pattern: {
              value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
              message: "Невалиден имейл адрес"
            }
          }} render={({
            field
          }) => <FormItem>
                                    <FormLabel className="text-foreground font-semibold">Имейл адрес</FormLabel>
                                    <FormControl>
                                        <Input type="email" placeholder="ivan@example.com" {...field} className="rounded-lg transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] focus:shadow-clay-hover" style={{
                boxShadow: "inset 0 2px 6px hsl(0 0% 0% / 0.1), inset 0 -1px 3px hsl(0 0% 100% / 0.3)"
              }} />
                                    </FormControl>
                                    <FormMessage />
                                </FormItem>} />
                    </div>

                    {}
                    <div ref={field3Ref} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${field3Visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-3'}`} style={{
          transitionDelay: '150ms'
        }}>
                        <FormField control={control} name="phone" render={({
            field
          }) => <FormItem>
                                    <FormLabel className="text-foreground font-semibold">Телефон</FormLabel>
                                    <FormControl>
                                        <Input type="tel" placeholder="+359 88 123 4567" {...field} className="rounded-lg transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] focus:shadow-clay-hover" style={{
                boxShadow: "inset 0 2px 6px hsl(0 0% 0% / 0.1), inset 0 -1px 3px hsl(0 0% 100% / 0.3)"
              }} />
                                    </FormControl>
                                    <FormMessage />
                                </FormItem>} />
                    </div>

                    {}
                    <div ref={field4Ref} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${field4Visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-3'}`} style={{
          transitionDelay: '200ms'
        }}>
                        <FormField control={control} name="subject" render={({
            field
          }) => <FormItem>
                                    <FormLabel className="text-foreground font-semibold">Тема</FormLabel>
                                    <FormControl>
                                        <Input placeholder="Запитване за резервация" {...field} className="rounded-lg transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] focus:shadow-clay-hover" style={{
                boxShadow: "inset 0 2px 6px hsl(0 0% 0% / 0.1), inset 0 -1px 3px hsl(0 0% 100% / 0.3)"
              }} />
                                    </FormControl>
                                    <FormMessage />
                                </FormItem>} />
                    </div>

                    {}
                    <div ref={field5Ref} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${field5Visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-3'}`} style={{
          transitionDelay: '250ms'
        }}>
                        <FormField control={control} name="message" rules={{
            required: "Съобщението е задължително",
            minLength: {
              value: 10,
              message: "Минимум 10 символа"
            }
          }} render={({
            field
          }) => <FormItem>
                                    <FormLabel className="text-foreground font-semibold">Съобщение</FormLabel>
                                    <FormControl>
                                        <Textarea placeholder="Опишете вашето запитване..." {...field} className="rounded-lg min-h-32 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] focus:shadow-clay-hover" style={{
                boxShadow: "inset 0 2px 6px hsl(0 0% 0% / 0.1), inset 0 -1px 3px hsl(0 0% 100% / 0.3)"
              }} />
                                    </FormControl>
                                    <FormMessage />
                                </FormItem>} />
                    </div>

                    {submitError && <div className="p-4 rounded-lg" style={{
          background: "hsl(0 85% 96%)",
          border: "1px solid hsl(0 85% 85%)"
        }}>
                            <p className="text-[hsl(0_85%_40%)] text-sm">{submitError}</p>
                        </div>}

                    <div ref={buttonRef} className={`pt-2 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${buttonVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-3'}`} style={{
          transitionDelay: '300ms'
        }}>
                        <Button type="submit" disabled={isSubmitting} className="w-full rounded-lg py-6 text-base font-semibold transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)] hover:scale-[1.03] active:scale-[0.98]" style={{
            background: "var(--color-primary)",
            color: "var(--color-foreground-primary)",
            boxShadow: "0 4px 12px hsl(15 85% 48% / 0.3)"
          }}>
                            {isSubmitting ? <>
                                    <Loader className="animate-spin mr-2 size-5" />
                                    Изпращане...
                                </> : 'Изпрати'}
                        </Button>
                    </div>
                </div>
            </Form>
        </div>;
}
function FloatingUtensil() {
  const [position, setPosition] = useState({
    x: 0,
    y: 0
  });
  const [rotation, setRotation] = useState(0);
  const animationFrameRef = useRef<number>();
  const timeRef = useRef(0);
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      const {
        clientX,
        clientY
      } = e;
      const centerX = window.innerWidth / 2;
      const centerY = window.innerHeight / 2;
      const offsetX = (clientX - centerX) / 40;
      const offsetY = (clientY - centerY) / 40;
      setPosition({
        x: offsetX,
        y: offsetY
      });
    };
    const animate = () => {
      timeRef.current += 0.01;
      setRotation(Math.sin(timeRef.current) * 5);
      animationFrameRef.current = requestAnimationFrame(animate);
    };
    window.addEventListener('mousemove', handleMouseMove);
    animationFrameRef.current = requestAnimationFrame(animate);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, []);
  return <div className="absolute pointer-events-none transition-transform duration-200 ease-out" style={{
    top: '15%',
    right: '10%',
    transform: `translate(${position.x}px, ${position.y}px) rotate(${rotation}deg)`,
    filter: "drop-shadow(0 8px 16px hsl(0 0% 0% / 0.15))"
  }}>
            <Utensils className="text-[hsl(15_85%_48%)]" style={{
      width: '120px',
      height: '120px',
      opacity: 0.6
    }} />
        </div>;
}